//------------------------------------------------------------------------------
// ReportDistributionModal
//------------------------------------------------------------------------------
import React, { useContext, useState, useEffect } from "react";

import { ApolloContext } from '../../../../utils/apolloProvider'
import AuthContext from '../../../../utils/authProvider'

import { EmailReport } from "./EmailReport";  //Function for sending email

import PropTypes from 'prop-types'
import { Button, Checkbox, Modal, Form, Input, Space, Typography } from 'antd'
const { Title, Text } = Typography
const { TextArea } = Input
import {
  MinusCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons'

import Editor from '../../../elements/common/Editor'

const ReportDistributionModal = ({
  isReportDistributionModalOpen, 
  setIsReportDistributionModalOpen,
  reportDefRef,
  reportTableColumns,
  reportTableExtraData,
  showSendButton,
  width,
}) => {
  if (!reportDefRef.current) {  //Return if a reportDefRef object does not exist
    console.log('Bad or missing reportDefRef')
    return (<></>)
  }

  const [form] = Form.useForm();
  const distribution = reportDefRef.currents
  const [distributionValues, setDistributionValues] = useState(reportDefRef.current.distribution);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    form.setFieldValue("emailRecipients",reportDefRef.current.distribution.emailRecipients)
    form.setFieldValue("emailFrom",reportDefRef.current.distribution.emailFrom)
    form.setFieldValue("emailSubject",reportDefRef.current.distribution.emailSubject)
    form.setFieldValue("emailText",reportDefRef.current.distribution.emailText)
    form.setFieldValue("emailAttachments",reportDefRef.current.distribution.emailAttachments)
  }, [reportDefRef.current, isReportDistributionModalOpen]);
  
  const handleCancel = () => {
    setIsReportDistributionModalOpen(false)
  }
  
  const handleOk = () => {
    form.validateFields().then((values) => {
      let updatedDefRef = {...reportDefRef.current}
      updatedDefRef.distribution = values
      reportDefRef.current = updatedDefRef
      setIsReportDistributionModalOpen(false)
      console.log('distribution.handleOk-result',reportDefRef.current,distributionValues,updatedDefRef)
    });
  };
  
  const Auth = useContext(AuthContext)
  const Apollo = useContext(ApolloContext)

  const handleSend = async () => {
    setIsProcessing(true);

    console.log('handleSend',reportDefRef.current.distribution)
    await EmailReport(Auth, Apollo, reportDefRef, reportTableColumns, reportTableExtraData)

    setIsProcessing(false);
    setIsReportDistributionModalOpen(false)
  }

  const modalFooter = showSendButton ? (
    <>
      <Button key="cancel" onClick={handleCancel}>Cancel</Button>
      <Button key="save" type="primary" onClick={handleSend} loading={isProcessing}>Send Email</Button>
    </>
  ) : (
    <>
      <Button key="cancel" onClick={handleCancel}>Cancel</Button>
      <Button key="save" type="primary" onClick={handleOk}>Ok</Button>    </>
  );

  return (
    <Modal
      title="Report Distribution"
      open={isReportDistributionModalOpen}
      closable={false}
      keyboard={false}
      footer={modalFooter} //Conditional footer based on showSendButton parm
      width={width}
    >
      <Form
        //name='reportDistributionModal'
        form={form}
        layout="horizontal"
        initialValues={distributionValues}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 20 }}
      >
        {/* <div>
          <Title level={5} underline>
            Email Recipients:{' '}
          </Title>
        </div> */}
        <Form.List
          name='emailRecipients' //How can we prevent empty entries?
          initialValue={reportDefRef.current.emailRecipients ? reportDefRef.current.emailRecipients : ''}
          disabled={showSendButton}
        >
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <Form.Item
                  label={index === 0 ? 'To:' : ' '}
                  required={false}
                  style={{ marginBottom: 0 }}
                >
                  <Input.Group compact>
                    <Form.Item
                      {...field}
                      name={[field.name, 'email']}
                      noStyle
                      rules={[
                        { required: true,  message: 'To email cannot be empty.' },
                        { type: 'email',   warningOnly: true, message: 'To email is invalid.' },
                        { type: 'string',  whitespace: true }
                      ]}                    >
                      <Input
                        style={{ width: 'calc(100% - 32px)' }}
                        placeholder="Enter recipient's email"
                        disabled={showSendButton}
                      />
                    </Form.Item>

                    {!showSendButton && (
                      <MinusCircleOutlined
                        style={{ marginLeft: 8, lineHeight: '32px' }}
                        onClick={() => remove(field.name)}
                      />
                    )}
                  </Input.Group>
                </Form.Item>
              ))}

              {!showSendButton && (  //Add recipient button only visible when editing distribution, not on send
                <Form.Item
                  wrapperCol={{ offset: 5, span: 20 }}   /* labelCol span = 5 */
                >
                  <Button
                    type='dashed'
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    disabled={showSendButton}
                    style={{ marginTop: 16 }}
                  >
                    Add a Recipient
                  </Button>
                </Form.Item>)
              }

            </>
          )}
        </Form.List>
        <Form.Item
          name='emailFrom'
          label='From:'
          rules={[
            { required: true, message: 'From email is required.' },
            {
              type: 'email',
              warningOnly: true,
              message: 'From email is invalid.'
            },
            { type: 'string', whitespace: true }
          ]}
          style={{ marginTop: "16px" }}

        >
          <Input
            type='text'
            placeholder="Enter the 'From' email address"
            disabled={showSendButton}
            // initialValue={reportDefRef.current.emailFrom ? reportDefRef.current.emailFrom  : ''}
          ></Input>
        </Form.Item>

        <Form.Item 
          name='emailSubject'
          label='Subject:'
          style={{ marginTop: "16px" }}
        >
          <Input
            type='text'
            placeholder="Enter the email 'Subject'"
            disabled={showSendButton}
            // initialValue={reportDefRef.current.emailSubject ? reportDefRef.current.emailSubject  : ''}
          ></Input>
        </Form.Item>

        <Form.Item
          name='emailText'
          style={{ marginTop: "16px" }}
          wrapperCol={{ offset: 5, span: 20 }}
        >
          <Editor
            disabled={showSendButton}
            initialValue={reportDefRef.current.emailText ? reportDefRef.current.emailText  : ''}
            formField='emailMessage'
            onChange={() => {}}
            onFocus={() => {}}
            onBlur={() => {}}
          />
        </Form.Item>

        <Form.Item
          name='emailAttachments'
          label='Attachments:'
          style={{ marginTop: "16px" }}
        >
          <Checkbox.Group  
            disabled={showSendButton}
          >
            <Checkbox value='pdf'>Report Pdf</Checkbox>
            <Checkbox value='csv'>Report CSV</Checkbox>
          </Checkbox.Group>
        </Form.Item>

      </Form>
    </Modal>
  )
}

// ReportDistributionModal.propTypes = {
//   visible: PropTypes.bool.isRequired,
//   setVisible: PropTypes.func.isRequired
// }

export default ReportDistributionModal;
